import { useCallback, useState } from 'react';
import { ComboBoxInputProps } from './useComboBoxInput';
import { IEntity } from '../../../../../../../types/api/entities/IEntity';
import { Section } from '../types/Section';
import { useComboBox } from './useComboBox';

export default function useMultiSelectComboBox<T extends IEntity, TResponse>(
  responseMapper: (response: TResponse) => Section<T>[],
  inputProps: ComboBoxInputProps,
  initialValues: T[] = []
) {
  const [selectedItems, setSelectedItems] = useState<T[]>(initialValues);
  const addItem = useCallback((item?: T) => item && setSelectedItems([item, ...selectedItems]), [selectedItems]);
  const unselectItem = useCallback(
    (id: string) => setSelectedItems(selectedItems.filter(item => item.id !== id)),
    [selectedItems]
  );

  const { getComboBoxProps, formInputRef } = useComboBox<T, TResponse>(responseMapper, addItem, inputProps);
  return { getComboBoxProps, selectedItems, unselectItem, formInputRef };
}
